import axios from "axios";
import EnvService from "./EnvService";

const api = axios.create({
	baseURL: `${EnvService.url}/api/v1/cocktails`
})
// api.interceptors.request.use( (error) => Promise.reject(error))

async function getAllRecipes(page = 0, size = 20, sort = "name") {
	return api({params: { page, size, sort }})
		.then(res => res.data)
}

async function searchRecipesByNameAndIngredient(all, page = 0, size = 20) {
	return api({
		params: { all, page, size }
	}).then(res => res.data)
}

async function searchRecipesByName(name, page = 0, size = 20) {
	return api({
		params: { name, page, size }
	}).then(res => res.data)
}

async function searchRecipesByIngredient(ingredient, page = 0, size = 20) {
	return api({
		params: { ingredient, page, size }
	}).then(res => res.data)
}

async function getRecipeByName(name) {
	return api({ url: `/${name}` })
		.then(res => res.data.data)
}

async function getRandomRecipe(size = 20) {
	return api({
		url: "/im-feeling-lucky",
		params: { size }
	}).then(res => res.data.data[0])
}

async function createRecipe(data) {
	return api({method: 'POST', data})
		.then(res => res.data.data.name || "")
}

export {
	createRecipe,
	getAllRecipes,
	getRecipeByName,
	searchRecipesByName,
	searchRecipesByIngredient,
	searchRecipesByNameAndIngredient,
	getRandomRecipe,
}
